import { paths } from './paths.config';


/* Weapons */
export const weapons = {
  basicWeapon: {
    src: `${paths.img.weapons}/weapon.png`,
  },
}

/* Projectiles */
export const projectiles = {
  redBeam: {
    src: `${paths.img.projectiles}/red-beam.png`,
  },
  blueBeam: {
    src: `${paths.img.projectiles}/blue-beam.png`,
  },
  greenBeam: {
    src: `${paths.img.projectiles}/green-beam.png`,
  },
  rocket: {
    src: `${paths.img.projectiles}/rocket.png`,
  }
}


/* Ships */
export const ships = {
  basicJet: {
    src: `${paths.img.ships}/spaceship.png`,
  },
  destroyer: {
    src: `${paths.img.ships}/alliedBoss.png`,
    width: 662 / 2,
    height: 1022 / 2,
  }
};

/* Animations */
export const animations = {
  ftl: {
    src: `${paths.img.animations}/light_004.png`,
    spriteWidth: 960,
    spriteHeight: 960,
    numberOfFramesBeforeNextStep: 1,
    frameCount: 5,
    stageCount: 5,
  }
}